import { useLocation } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { appointmentDetailRegex } from "components/NavBar/routes";
import { PATHS } from "router/paths";

export const DealerDocsButton = () => {
  const location = useLocation();

  if (!appointmentDetailRegex.test(location.pathname)) return null;

  return (
    <div className="pointer" onClick={() => window.open(PATHS.DEALER_DOCUMENTATION, "_blank")}>
      <Icon className="book open cover" color="black" />
    </div>
  );
};
